import React, { useState } from "react";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Quality_Plan_table() {
  const data = [
    {
      srNo: 101,
      type: "Use Of CRM/Srms",
      frequency: "Quarterly",
      parameters: [
        { name: "ASH%", value: "26.50" },
        { name: "VM%", value: "26.50" },
        { name: "GCV(K.Cal/Kg)", value: "26.50" },
      ],
    },
  ];

     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Type Of Verification</th>
                <th>Frequency</th>
                <th colSpan="2">Acceptance Parameter Criteria</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) =>
                item.parameters.map((param, i) => (
                  <tr key={i}>
                    {i === 0 && (
                      <>
                        <td rowSpan={item.parameters.length}>{item.srNo}</td>
                        <td rowSpan={item.parameters.length}>{item.type}</td>
                        <td rowSpan={item.parameters.length}>{item.frequency}</td>
                      </>
                    )}
                    <td>{param.name}</td>
                    <td>{param.value}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
       <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}

export default Quality_Plan_table;
